/* eslint-disable prettier/prettier */
import { Form } from 'formik';
import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import BaseCheckbox from 'components/Checkbox';
import BaseToggleCard from 'components/ToggleCard';

interface StyledProps {
  $spacingBottom?: boolean;
}

interface GroupSelectLabelProps {
  isError?: boolean;
}

export const Wrapper = styled.div`
  max-width: 1300px;

  @media ${({ theme }) => theme.device.mobile} {
    max-width: none;
    height: 100vh;
  }
`;

export const FormContainer = styled(Form) <StyledProps>`
  background-color: ${ColorPalette.HEX.Lotion};
  padding-bottom: ${({ $spacingBottom }) => $spacingBottom && '100px'};

  @media ${({ theme }) => theme.device.desktop} {
    padding: 0;
    background-color: ${ColorPalette.Transparent};
  }
`;

export const Divider = styled.div`
  height: 1px;
  border-bottom: solid 1px ${({ theme }) => theme.group.division};
  padding: 10px;
`;

export const GroupSelectLabel = styled.span<GroupSelectLabelProps>`
  color: ${({ isError }) => (isError ? ColorPalette.HEX.RedRYB3 : ColorPalette.HEX.DimGray)};
  padding: 16px 0 8px 0;
`;

export const ToggleCard = styled(BaseToggleCard)`
  margin: 16px 0;
`;

export const Checkbox = styled(BaseCheckbox)`
  align-items: flex-start;
  margin-top: 24px;

  .checkbox {
    margin-right: 20px;
  }
`;

export const CheckboxLabel = styled.span`
  font-size: 14px;
  line-height: 1.57;
  color: ${ColorPalette.HEX.DimGray};
`;

export const TextTypeUser = styled.div`
  color: ${({ theme }) => theme.userFormSuccess.emailColor};
`;

export const UserGroupListContainer = styled.div`
  margin: 16px -16px 0 -24px;
`;

export const SectionDateOfBirth = styled.section`
  padding: 0px 0 48px 0;
  margin-top: -18px;

  @media ${({ theme }) => theme.device.desktop} {
    display: grid;
    grid-template-columns: 1fr 2fr;
    grid-gap: 32px;

    padding-left: 0;
    padding-right: 0;
  }

  @media ${({ theme }) => theme.device.mobile} {
    padding: 0px 16px 32px 16px;
    margin-top: -20px;
  }
`;

export const Content = styled.div`
  @media ${({ theme }) => theme.device.desktop} {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 5px;
  }
`;

export const ErrorValidation = styled.span`
  padding-top: 4px;
  font-size: 12px;
  color: ${ColorPalette.HEX.TartOrange};
`;
